import MediaInserter from '@intercom/embercom-composer/components/media-inserter';
export default MediaInserter;
